import type { SlideProps } from "@/engine/app/offsite-config";

// Quelle: Make.com Org "SVO" (eu2), Ausführungslogs Stand 16.09.2026
// (Szenario "Zählerstandsübermittlung V1 (PROD)": 50+ Läufe seit 31.08.).
const STATS = [
  { value: "50+", label: "Zählerstände in 2 Wochen automatisch in kVASy verbucht" },
  { value: "2", label: "Zendesk-Vorgangsarten komplett ohne Handarbeit: Zählerstand & IBAN-Änderung" },
  { value: "8", label: "KI-generierte Ansagen in der Telefonanlage" },
];

export function Slide15LiveSysteme(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 380,
          height: 380,
          top: "-100px",
          right: "-100px",
          background: "var(--svo-blau)",
          opacity: 0.28,
        }}
      />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Live bei SVO</div>
        <h1 className="deck-title rise rise-2">
          Das läuft <br />
          <span className="accent">heute schon</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Make-Webservices, Zendesk-Automatisierung, KI-Ansagen — im Betrieb,
          nicht im Labor.
        </p>
      </header>

      <div className="deck-big">
        <div className="big-grid rise rise-4">
          {STATS.map((s, i) => (
            <div key={s.label} className="big-tile">
              <div className="tile-eyebrow">0{i + 1}</div>
              <div className="tile-value">{s.value}</div>
              <div className="tile-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
